import { useHubble } from '@seek/hubble';
import { useCallback } from 'react';

import { CAJA_FLOW_TYPE_CREATE } from 'src/app/shared/constants/tealium';
import { useShoppingCart } from 'src/app/shared/hooks/useShoppingCart';
import { log } from 'src/app/utils/logging';

import { usePage } from '../usePage';
import { useQueryParam } from '../useQueryParam';

export const useHubbleTrackEventHandler = () => {
  const draftId = useQueryParam('draftid');
  const flowType = CAJA_FLOW_TYPE_CREATE;
  const pageId = usePage();
  const { productSetId } = useShoppingCart();

  const hubble = useHubble();

  const sendHubbleTrackEvent = useCallback(
    (eventName: any, eventData: any) => {
      if (draftId && flowType && pageId && productSetId) {
        hubble.trackEvent(eventName, {
          ...eventData,
          draftId,
          postingFlowType: flowType,
          postingFlowPageName: pageId,
          productSetId,
          opportunityId: draftId,
        });
      } else {
        log.warn(
          'useHubbleTrackEventHandler | missing required data for tracking',
          {
            draftId,
            flowType,
            pageId,
            productSetId,
          },
        );
      }
    },
    [hubble, draftId, flowType, pageId, productSetId],
  );

  return { sendHubbleTrackEvent };
};
